
function Ticket() {
  window.location.href = 'https://goopps.com/event/detail/33817/grab-it-fast-2022-telkom-university';
  }
  

export default Ticket